import { Controller } from "@hotwired/stimulus"

// Toggles the custom date-range inputs on the Governance Activity filters
// form. Only visible when the "Custom" timespan radio is selected so users
// don't see both a preset (e.g. 7d) AND a date range, which is ambiguous.
export default class extends Controller {
  static targets = ["customRange"]

  toggleCustom(event) {
    const isCustom = event.target.value === "custom"
    this.customRangeTarget.classList.toggle("d-none", !isCustom)
  }
}
